// Copyright (c) 2025 Deere & Company

import React, {PropTypes} from 'react';
import Accordion from '../../../../shared/components/accordion';
import File from '@deere/cps-it.warranty-model-factory/lib/file';
import {FormattedMessage} from 'react-intl';
import KeyValuePair from '@deere/cps-it.warranty-model-factory/lib/key-value-pair';
import ReturnedPartInfoForm from './returned-part-info-form';
import RgaAdditionalDataInfo from '../../../rga-search-results/state/rga-additional-data-info';
import RgaDetails from '../../../rga-search-results/state/rga-details';
import RgaQuestionAnswer from '../../../rga-search-results/state/rga-question-answer';
import Security from '@deere/cps-it.warranty-model-factory/lib/security';

const ReturnedPartInfoAccordion = props => {

    const body = (
        <ReturnedPartInfoForm
            actions={props.actions}
            additionalDataFlag={props.additionalDataFlag}
            additionalDataInfo={props.additionalDataInfo}
            additionalDataTest={props.additionalDataTest}
            additionalDataType={props.additionalDataType}
            analysisStatus={props.analysisStatus}
            busyCounter={props.busyCounter}
            fileCollection={props.fileCollection}
            partReqStatus={props.partReqStatus}
            queryParams={props.queryParams}
            rgaDetails={props.rgaDetails}
            rgaQuestionAnswer={props.rgaQuestionAnswer}
            rgaUnits={props.rgaUnits}
            security={props.security}
        />
    );

    const title = (
        <FormattedMessage
            id='Returned Part Information'
        />
    );

    return true &&
        <Accordion
            accordionId='part-request-analysis-accordion'
            body={body}
            isExpanded={props.queryParams && (props.queryParams.tab === 'additional-data' || props.queryParams.tab === 'analyst' || props.queryParams.tab === 'attachment' || props.queryParams.tab === 'q-and-a')}
            secondaryHeaderNode={null}
            title={title}
        />;

};

ReturnedPartInfoAccordion.displayName = 'ReturnedPartInfoAccordion';
ReturnedPartInfoAccordion.propTypes = {
    actions: PropTypes.object.isRequired,
    additionalDataFlag: PropTypes.bool.isRequired,
    additionalDataInfo: PropTypes.instanceOf(RgaAdditionalDataInfo).isRequired,
    additionalDataTest: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    additionalDataType: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    analysisStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    busyCounter: PropTypes.number.isRequired,
    fileCollection: PropTypes.arrayOf(PropTypes.instanceOf(File)).isRequired,
    partReqStatus: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    queryParams: PropTypes.object.isRequired,
    rgaDetails: PropTypes.instanceOf(RgaDetails).isRequired,
    rgaQuestionAnswer: PropTypes.arrayOf(PropTypes.instanceOf(RgaQuestionAnswer)).isRequired,
    rgaUnits: PropTypes.arrayOf(PropTypes.instanceOf(KeyValuePair)).isRequired,
    security: PropTypes.instanceOf(Security).isRequired
};

export default ReturnedPartInfoAccordion;



// WEBPACK FOOTER //
// ./src/rga/recalled-part-analysis/components/returned-part-information/returned-part-information-accordion.js